import SubCardTitle from "../../../../components/styled/SubCardTitle";
import { arrayMap, chunkArray } from "../../../../utils/array.utils";
import { BlankCircleIcon, FillCircleIcon } from "../../../../utils/icon.utils";

export default function VehicleInventoryAccessories({ data }) {
  const chunkData = chunkArray(data, 10);
  let serialNumber = 1;
  return (
    <div className="card border-0" style={{ height: `100%` }}>
      <div className="card-body">
        <SubCardTitle>Accessories Acknowledged</SubCardTitle>
        <div className="row g-3">
          {arrayMap(chunkData, (item, i) => {
            return (
              <div key={i} className="col-12 col-md-6">
                <ul className="list-unstyled mb-0">
                  {arrayMap(item, (innerItem, j) => {
                    return (
                      <li key={j}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div style={{ width: `60%` }}>
                            {serialNumber++}. {innerItem?.label ?? ""}
                            {innerItem?.remarks ? ` (${innerItem.remarks})` : ""}
                          </div>
                          <div
                            style={{ width: `40%` }}
                            className="d-flex align-items-center flex-wrap">
                            <span>
                              {innerItem?.is_okay === "1" ? (
                                <FillCircleIcon />
                              ) : (
                                <BlankCircleIcon />
                              )}{" "}
                              Yes
                            </span>
                            &nbsp;&nbsp;
                            <span>
                              {innerItem?.is_okay === "2" ? (
                                <FillCircleIcon />
                              ) : (
                                <BlankCircleIcon />
                              )}{" "}
                              No
                            </span>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          }) || <p>No accessories</p>}
        </div>
      </div>
    </div>
  );
}
